/**
 * Which recognition engine actually runs a scan — a manual operator choice,
 * not an automatic per-photo fallback chain. This lets the venue owner
 * compare on-device against the Anthropic relay by switching modes
 * wholesale and watching real results over real games, rather than having
 * every scan silently decide for itself which engine to trust (which would
 * make it impossible to tell how either one is actually doing on its own).
 */

const ENGINE_KEY = 'mahjong-scorer:recognitionEngine';

export type RecognitionEngine = 'on-device' | 'relay';

/** On-device is the default now that it's shipped — see the admin Recognition Usage screen to switch. */
export function getRecognitionEngine(): RecognitionEngine {
  return localStorage.getItem(ENGINE_KEY) === 'relay' ? 'relay' : 'on-device';
}

export function setRecognitionEngine(engine: RecognitionEngine): void {
  localStorage.setItem(ENGINE_KEY, engine);
}
